import axios from "../reducers/authinterceptor";
import plainAxios from "axios";
import AuthHeader from "./auth.header";

const API_URL = process.env.REACT_APP_API_URL;

// Survey CRUD
const createSurvey = (data) => {
    return axios.post(API_URL + "/admin/surveys", data, { headers: AuthHeader.authHeader() });
};

const getSurveys = () => {
    return axios.get(API_URL + "/admin/surveys", { headers: AuthHeader.authHeader() });
};

const getAllSurveys = () => {
    return axios.get(API_URL + "/admin/super/surveys", { headers: AuthHeader.authHeader() });
};

const getSurvey = (id) => {
    return axios.get(API_URL + "/admin/surveys/" + id, { headers: AuthHeader.authHeader() });
};

const updateSurvey = (id, data) => {
    return axios.put(API_URL + "/admin/surveys/" + id, data, { headers: AuthHeader.authHeader() });
};

const deleteSurvey = (id) => {
    return axios.delete(API_URL + "/admin/surveys/" + id, { headers: AuthHeader.authHeader() });
};

const updateSurveyFields = (surveyId, fieldIds) => {
    return axios.put(API_URL + "/admin/surveys/" + surveyId + "/fields", { fieldIds }, { headers: AuthHeader.authHeader() });
};

// Field CRUD
const createField = (data) => {
    return axios.post(API_URL + "/admin/surveyfields", data, { headers: AuthHeader.authHeader() });
};

const getFields = () => {
    return axios.get(API_URL + "/admin/surveyfields", { headers: AuthHeader.authHeader() });
};

const getField = (id) => {
    return axios.get(API_URL + "/admin/surveyfields/" + id, { headers: AuthHeader.authHeader() });
};

const updateField = (id, data) => {
    return axios.put(API_URL + "/admin/surveyfields/" + id, data, { headers: AuthHeader.authHeader() });
};

const deleteField = (id) => {
    return axios.delete(API_URL + "/admin/surveyfields/" + id, { headers: AuthHeader.authHeader() });
};

// Public survey
// Use plainAxios (not the auth interceptor) so that a 404/inactive response
// is handled locally by the PublicSurvey component instead of redirecting
// to the global /notfound page.
const getPublicSurvey = (code) => {
    return plainAxios.get(API_URL + "/public/survey/" + code);
};

const submitSurvey = (code, responses) => {
    return plainAxios.post(API_URL + "/public/survey/" + code + "/submit", { responses });
};

const getProductForSurvey = (styleId, subsiteId) => {
    return plainAxios.get(API_URL + "/public/survey/product/" + styleId + (subsiteId ? "?subsiteId=" + subsiteId : ""));
};

const getAddressesForSurvey = (subsiteId) => {
    return plainAxios.get(API_URL + "/public/survey/addresses/" + subsiteId);
};

// Responses
const getResponses = (surveyId) => {
    return axios.get(API_URL + "/admin/surveys/" + surveyId + "/responses", { headers: AuthHeader.authHeader() });
};

const downloadResponses = (surveyId) => {
    return axios.get(API_URL + "/admin/surveys/" + surveyId + "/responses/download", {
        headers: AuthHeader.authHeader(),
        responseType: 'blob'
    });
};

const deleteResponse = (id) => {
    return axios.delete(API_URL + "/admin/surveyresponses/" + id, { headers: AuthHeader.authHeader() });
};

const updateResponse = (id, fieldValues) => {
    return axios.put(API_URL + "/admin/surveyresponses/" + id, { fieldValues }, { headers: AuthHeader.authHeader() });
};

const sendReportNow = (surveyId) => {
    return axios.post(API_URL + "/admin/surveys/" + surveyId + "/sendreport", {}, { headers: AuthHeader.authHeader() });
};

const getReportSchedules = () => {
    return axios.get(API_URL + "/admin/surveys/report-schedules", { headers: AuthHeader.authHeader() });
};

const uploadImage = (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return axios.post(API_URL + "/admin/surveys/uploadimage", formData, {
        headers: {
            ...AuthHeader.authHeader(),
            'Content-Type': 'multipart/form-data'
        }
    });
};

const SurveyService = {
    createSurvey,
    getSurveys,
    getAllSurveys,
    getSurvey,
    updateSurvey,
    deleteSurvey,
    updateSurveyFields,
    createField,
    getFields,
    getField,
    updateField,
    deleteField,
    getPublicSurvey,
    submitSurvey,
    getResponses,
    downloadResponses,
    deleteResponse,
    updateResponse,
    getProductForSurvey,
    getAddressesForSurvey,
    sendReportNow,
    getReportSchedules,
    uploadImage
};

export default SurveyService;

